import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Agenda stack layout
 */
export default function AgendaLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen
        name="[id]"
        options={{
          presentation: "card",
        }}
      />
      <Stack.Screen
        name="edit/[id]"
        options={{
          presentation: "modal",
        }}
      />
    </Stack>
  );
}

